<table *ngIf="flightComms.length; else placeholder" class="data-block">
  <thead>
    <tr>
      <th *ngIf="editModeSet" class="data-block__label">Actions:</th>
      <th class="data-block__label">Type:</th>
      <th class="data-block__label">Frequency / Phone:</th>
      <th class="data-block__label">Sector / Comments:</th>
      <th class="data-block__label">Call Sign:</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let comm of sortedFlightComms" class="data-block__item">
      <td *ngIf="editModeSet && isIslandSource" class="data-block__value">
        <div class="comm__actions">
          <mat-icon (click)="openEditCommDialog(comm)" *ngIf="editModeSet && isIslandSource" class="edit-icon" mat-tooltip="Edit" aria-label="Edit communication">edit</mat-icon>
          <mat-icon (click)="deleteComm(comm)" *ngIf="editModeSet && isIslandSource" class="delete-icon" mat-tooltip="Delete" aria-label="Delete communication">delete_outline</mat-icon>
        </div>
      </td>
      <td class="data-block__value">{{ comm.service }}</td>
      <td class="data-block__value">
        {{ comm.formattedFreq }}
        <br *ngIf="comm.frequency && comm.phoneNumber">
        <ng-container *ngIf="comm.phoneNumber">{{ comm.phoneNumber | phone }}</ng-container>
      </td>
      <td class="data-block__value">{{ comm.sector }}</td>
      <td class="data-block__value">{{ comm.radioCall }}</td>
    </tr>
  </tbody>
</table>
<ng-template #placeholder>
  <div class="detail-page__placeholder">
    <mat-icon class="detail-page__placeholder-icon">info</mat-icon>
    <div class="detail-page__placeholder-message">There are no frequencies listed for {{identifier.toUpperCase().startsWith('ZZ') ? 'this airport' : identifier}}.</div>
  </div>
</ng-template>
